import React from 'react';

const GuestChatWidget = () => {
    // Firebase chat has been removed to allow access in China.
    // This component now renders nothing to prevent errors.
    return null;
};

export default GuestChatWidget;